<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-flex align-items-center">
       <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un newsletter"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <!-- <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> -->
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr >
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Email
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Statut
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              >ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(newsletter, index) in newsletters" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ newsletter.email }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ newsletter.estAbonne ? "Abonné" : "Désabonné" }}
              </td>
              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>  
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="#"
                        @click="switchNewsletters(newsletter.id)"
                        :class="{ 'disabled': !newsletter.estAbonne }"
                      >
                        <i
                          class="flaticon-flash lh-1 me-8 position-relative top-1"
                        ></i>
                        <span>Se désabonner</span>
                      </a>
                    </li>
                  </ul>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref} from "vue";
import Swal from "sweetalert2";
import { Contact } from "../../models/Contact";
import ApiService from "../../services/ApiService";
import { format_date,suppression,format_Date, hideModal, showModal,separateur, error,success } from "../../utils/utils";
import PaginationComponent from '../Utilities/Pagination.vue';
import JwtService from "../../services/JwtService";
import axios from "axios";
export default defineComponent({
  name: "ListNewsletter",
  components: {
    PaginationComponent
  },
  setup(){
    
    onMounted(() => {
      getAllNewsletter();
    });

    const newsletters = ref<Array<any>>([]);   
    const newsletter = ref<any>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllNewsletter(page_, limit_);
      } catch (error) {
        //
      }
    };

     function rechercher(){
      getAllNewsletter(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getAllNewsletter(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/newsletters?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          newsletters.value = data.data.data;
          console.log("EEEEEEEE ===> ",newsletters.value);
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
      });
    }
    
    const switchNewsletters = (id) => {
        Swal.fire({
    title: "Confirmer la désinscription ?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Oui, désabonner",
    cancelButtonText: "Annuler",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .put(`/newsletters/abonne/${id}`)
        .then(({ data }) => {
          if (data.code == 200) {
            success(data.message);
            getAllNewsletter();
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }
     });
};

    

    
    

    
    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

        return { newsletters,
            newsletter,
        checkPermission,
        getAllNewsletter,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        rechercher,
        searchTerm,
        switchNewsletters
    
  };
  },
});
</script>